module.exports = __webpack_public_path__ + "e04d8fa40e4f4072ba07d69617d8a5fb.pdf";